/**
 * Contrato canónico de GET api/v1/roles/current tras camelize (humps).
 * BE envía snake_case; FE trabaja siempre en camelCase.
 */
export interface ICurrentPermissionsFlags {
  manageInternalCourses: boolean
  manageExternalCourses: boolean
  manageLearningPaths: boolean
  viewCourseDetails: boolean
  downloadReport: boolean
  manageParticipants: boolean
  manageProgress: boolean
  manageCourseRequests: boolean
  manageMessages: boolean
  viewMonitoring: boolean
}

export interface ICurrentLearningPathScope {
  id: number
  courses: number[]
}

export interface ICurrentPermissions {
  /** true cuando AbacService#admin? (JWT admin o rol ABAC is_default). */
  isAdmin?: boolean
  learningPath: ICurrentLearningPathScope[]
  courses: number[]
  permissions: ICurrentPermissionsFlags | Record<string, never>
}

export type PermissionKey = keyof ICurrentPermissionsFlags

export const PERMISSION_KEYS: PermissionKey[] = [
  'manageInternalCourses',
  'manageExternalCourses',
  'manageLearningPaths',
  'viewCourseDetails',
  'downloadReport',
  'manageParticipants',
  'manageProgress',
  'manageCourseRequests',
  'manageMessages',
  'viewMonitoring',
]

export const FULL_PERMISSIONS: ICurrentPermissionsFlags = {
  manageInternalCourses: true,
  manageExternalCourses: true,
  manageLearningPaths: true,
  viewCourseDetails: true,
  downloadReport: true,
  manageParticipants: true,
  manageProgress: true,
  manageCourseRequests: true,
  manageMessages: true,
  viewMonitoring: true,
}

export const EMPTY_CURRENT_PERMISSIONS: ICurrentPermissions = {
  learningPath: [],
  courses: [],
  permissions: {},
}

export const FULL_CURRENT_PERMISSIONS: ICurrentPermissions = {
  learningPath: [],
  courses: [],
  permissions: FULL_PERMISSIONS,
}
